import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BCPSearch, BCPSquarePlus, BCPUserGroup } from "../icons/bcp/BCPIcons";
import InfoContainer from "../layout/InfoContainer";
import OrganizationCardSmall from "../layout/OrganizationCardSmall";
import ListResponsive from "../other/ListResponsive";
import { getData } from "../utilities/UtilityFunctions";
import { AuthContext } from "../user/BCPAuthProvider";

export default function FollowedOrganizations(props) {
  const [loading, setLoading] = useState(true);
  const [organizations, setOrganizations] = useState(null);
  const authContext = React.useContext(AuthContext);

  useEffect(() => {
    const check = async () => {
      if (!authContext?.authState?.identity?.userId) {
        setLoading(false);
        return;
      }

      try {
        const userData = await getData(
          `/users/${authContext.authState.identity.userId}`
        );
        const followedIds = userData?.followingOrganizationIds || [];

        if (followedIds.length === 0) {
          setOrganizations([]);
          setLoading(false);
          return;
        }

        const orgPromises = followedIds.map((id) =>
          getData(`/gamestores/${id}`, {
            queryStringParameters: {
              "expand[]": ["location"],
            },
          })
        );

        const orgs = await Promise.all(orgPromises);

        setOrganizations(orgs);
      } catch (err) {
        console.error("Error fetching followed organizations:", err);
        setOrganizations([]);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, [authContext?.authState?.identity?.userId]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <Typography variant="h3" fontWeight="700">
          My Followed Organizations
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Button
          variant="contained"
          href="/organize/game-stores"
          startIcon={<BCPUserGroup />}
          fullWidth
        >
          View All My Organizations
        </Button>
      </Grid>

      <Grid item xs={12}>
        {loading || organizations?.length ? (
          <ListResponsive
            name="My Followed Organizations"
            originalList={
              loading ? null : organizations?.length ? organizations : null
            }
            doPages
            initialRowsPerPage={9}
            itemsPerPage={[3]}
            centerNav
            rowProps={{
              mapFunction: (row, index) => {
                const currentUserId = authContext?.authState?.identity?.userId;
                const canOrganize = row?.ownerId === currentUserId;
                return (
                  <Grid key={index} item xs={12} sm={6} md={4} sx={{ p: 1 }}>
                  <OrganizationCardSmall
                    organization={row}
                    key={row?.id || index}
                    organize={canOrganize}
                  />
                </Grid>
              );
            },
          }}  
          />  
        ) : !loading && !organizations?.length ? (
          <InfoContainer
            title="No followed organizations found."
            body={"You are not currently following any organizations."}
            ActionButton={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  href="/play/organizations"
                  startIcon={<BCPSearch />}
                >
                  Find Organizations
                </Button>
                <Button
                  variant="contained"
                  href="/organization"
                  startIcon={<BCPSquarePlus />}
                >
                  Create Organization
                </Button>
              </Box>
            }
            sx={{ mt: 1, mb: 1 }}
          />
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
}
